import React from 'react';
import { PageType } from '@tcs/create-account/utils/prismic/types';

interface SeoHeadTagsProps {
  page: PageType<unknown>;
}

const SeoHeadTags: React.FC<SeoHeadTagsProps> = ({ page }) => {
  const {
    seo_description,
    seo_keywords,
    seo_og_title,
    seo_og_description,
    seo_og_image,
  } = page;
  return (
    <>
      <meta name="description" content={seo_description} />
      <meta name="keywords" content={seo_keywords} />

      <meta name="twitter:card" content="summary" />
      <meta property="og:title" content={seo_og_title} />
      <meta property="og:description" content={seo_og_description} />
      <meta property="og:image" content={seo_og_image?.url} />
      <meta
        property="og:image:width"
        content={`${seo_og_image?.dimensions?.width}`}
      />
      <meta
        property="og:image:height"
        content={`${seo_og_image?.dimensions?.height}`}
      />
    </>
  );
};

export default SeoHeadTags;
